import { IconButton } from '../../../../elements/controls/IconButton/IconButton.js'

export const LiveOrCatchUpButton = ({ onPress, isCatchUpShown, withLabel = true, ...props }) => {
  return (
    <IconButton
      {...props}
      name={isCatchUpShown ? 'live' : 'catchUp'}
      title={isCatchUpShown ? 'Play Live' : 'Catch Up'}
      onPress={onPress}
    />
  )
}
